module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/18FTktA/tc-custom/9780897338974.jpg?1718078974143",
      "alt": "This image is the cover for the book Best Horror Stories of Arthur Conan Doyle"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Best Horror Stories of Arthur Conan Doyle\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("These horror stories -- never before compiled in one volume -- are carefully crafted, compelling and believable. Written in about the same decade as the Sherlock Holmes series, they will convince you that Arthur Conan Doyle was a master of more than just the detective story. ")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Arthur Conan Doyle, Charles Waugh, Martin H. Greenberg, Frank D. McSherry\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Arthur Conan Doyle (1859–1930) practiced medicine in the resort town of Southsea, England, and wrote stories while waiting for his patients to arrive. In 1886, he created two of the greatest fictional characters of all time: the detective Sherlock Holmes and his partner, Dr. Watson. Over the course of four novels and fifty-six short stories, Conan Doyle set a standard for crime fiction that has yet to be surpassed.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Chicago Review Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0